import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import useDate from '../../hooks/app/useDate';
import { Tooltip } from '@mui/material';
import { capitalizarPrimeraLetra } from '../../utils';

const TextStatusUnitOfLearning = ({ id, startDate, endDate }) => {
  const { determinateStatus } = useDate();
  const status = determinateStatus(startDate, endDate)

  return (
    <Tooltip id={`text-status-${id}-${status}`} title={`${capitalizarPrimeraLetra(status)}`} arrow>
      <FontAwesomeIcon icon={'circle'} className={status === 'active' ? 'text-accent' : 'text-muted'} />
    </Tooltip>
  )
}

export default TextStatusUnitOfLearning